import { useCallback, useEffect, useMemo, useState } from "react";
import { filiadoAPI } from "../../servicos/filiado";
import { useNavigate } from "react-router-dom";
import ListagemFeedback from "../Listagem/feedback";
import ListagemOpcoes from "../Listagem/opcoes";
import Topo from "../Topo/topo";
import FiliadoCard from "./card";
import Paginacao from "../Listagem/paginacao";
import { DataTable } from "../ui/data-table";
import ColumnToggleDropdown from "../ui/column-toggle-dropdown";

function normalizarAssociado(indicador) {
    if (typeof indicador === 'string') {
        const valor = indicador.trim().toLowerCase();
        return ['s', 'sim', '1', 'true'].includes(valor);
    }
    if (typeof indicador === 'number') {
        return indicador === 1;
    }
    return Boolean(indicador);
}

function obterDescricaoAssociado(filiado) {
    const associadoRaw = filiado?.fi100_ind_associado ?? false;
    return normalizarAssociado(associadoRaw) ? 'É associado' : 'Não é associado';
}

function FiliadoTabela() {

    const breadcrumbs = ['Admin','Filiados'];
    const [PesquisaFiliados, setPesquisaFiliados] = useState([]);
    const [filtroTexto, setFiltroTexto] = useState('');

    const [exibeErro, setExibeErro] = useState(false);    
    const [mensagemErro, setMensagemErro] = useState('');    

    const [exibeSucesso, setExibeSucesso] = useState(false);    
    const [mensagemSucesso, setMensagemSucesso] = useState('');    

    const fetchFiliados = useCallback(() => {

        filiadoAPI.get('/')
        .then(resposta => {
            setPesquisaFiliados(resposta.data);
        })
        .catch(erro => {          
            if(erro?.resposta?.data?.message){
                setExibeErro(true);
                setMensagemErro(erro.resposta.data.message);
            }else{
                if (erro.response?.status === 401) {
                    setExibeErro(true);
                    setMensagemErro('Ops! Sessão Expirada! Faça um novo login.');
                  }else{
                    setExibeErro(true);
                    setMensagemErro('Ops! Ocorreu um erro inesperado.');
                  }                                           
            }        
        })               
        
    }, []);

    useEffect(() => {
        fetchFiliados();
    }, [fetchFiliados]);

    const navigate = useNavigate();
    const Editar = useCallback((key) => {
        let path = `/admin/filiado/editar/${key}`;
        navigate(path);
    }, [navigate]);

    const ResetarSenha = useCallback((key) => {
        let path = `/admin/filiado/senha/${key}`;
        navigate(path);
    }, [navigate]);
    

    const DesativarFiliado = useCallback((key) => {

        setExibeSucesso(false);
        setMensagemSucesso('');    
        setExibeErro(false);
        setMensagemErro('');

        filiadoAPI.patch(`/desativar/${key}`)
            .then(resposta => {
                setExibeSucesso(true);
                setMensagemSucesso('Filiado atualizado com sucesso.');    
                fetchFiliados();
            })
            .catch(erro => {
                if (erro?.resposta?.data?.message) {                    
                    setExibeErro(true);
                    setMensagemErro(erro.resposta.data.message);
                } else {
                    if (erro.response?.status === 401) {
                        setExibeErro(true);
                        setMensagemErro('Ops! Sessão Expirada! Faça um novo login.');    
                    } else {
                        setExibeErro(true);
                        setMensagemErro('Ops! Ocorreu um erro inesperado.');
                    }

                }
            })
    }, [fetchFiliados]);

    const AtivarFiliado = useCallback((key) => {

        setExibeSucesso(false);
        setMensagemSucesso('');    
        setExibeErro(false);
        setMensagemErro('');

        filiadoAPI.patch(`/reativar/${key}`)
            .then(resposta => {
                setExibeSucesso(true);
                setMensagemSucesso('Filiado atualizado com sucesso.');    
                fetchFiliados();
            })
            .catch(erro => {
                if (erro?.resposta?.data?.message) {                    
                    setExibeErro(true);
                    setMensagemErro(erro.resposta.data.message);
                } else {
                    if (erro.response?.status === 401) {
                        setExibeErro(true);
                        setMensagemErro('Ops! Sessão Expirada! Faça um novo login.');    
                    } else {
                        setExibeErro(true);
                        setMensagemErro('Ops! Ocorreu um erro inesperado.');
                    }

                }
            })

    }, [fetchFiliados]);

    const colunasBase = useMemo(() => [
        {
            id: 'filiado',
            header: () => 'Filiado',
            label: 'Filiado',
            canHide: false,
            className: 'tw-align-top tw-min-w-[220px]',
            cell: ({ row }) => (
                <div class="tw-flex tw-flex-col tw-gap-1">
                    <span class="tw-font-semibold tw-text-slate-800 dark:tw-text-white">{row.fi100_dsc_filiado}</span>
                    <span class="tw-text-xs tw-uppercase tw-text-slate-500 dark:tw-text-slate-400">{obterDescricaoAssociado(row)}</span>
                    {row.fi100_dsc_email && (
                        <span class="email">{row.fi100_dsc_email}</span>
                    )}
                </div>
            ),
        },
        {
            id: 'cnpj',
            header: () => 'CNPJ',
            label: 'CNPJ',
            accessorKey: 'fi100_num_cnpj',
            className: 'tw-font-mono tw-text-sm tw-text-slate-700 dark:tw-text-slate-200',
        },
        {
            id: 'telefone',
            header: () => 'Telefone',
            label: 'Telefone',
            accessorKey: 'fi100_num_telefone',
            className: 'tw-whitespace-nowrap tw-text-slate-700 dark:tw-text-slate-200',
        },
        {
            id: 'status',
            header: () => 'Status',
            label: 'Status',
            className: 'tw-align-top',
            cell: ({ row }) => (
                <button
                    type="button"
                    class={`tw-inline-flex tw-items-center tw-justify-center tw-rounded-full tw-border tw-px-3 tw-py-1 tw-text-sm tw-font-semibold ${
                        row.fi100_ind_desativado
                            ? 'tw-border-rose-200 tw-bg-rose-50 tw-text-rose-600 dark:tw-border-rose-500/40 dark:tw-bg-rose-500/15 dark:tw-text-rose-300'
                            : 'tw-border-emerald-200 tw-bg-emerald-50 tw-text-emerald-700 dark:tw-border-emerald-400/40 dark:tw-bg-emerald-400/15 dark:tw-text-emerald-200'
                    }`}
                    onClick={() =>
                        row.fi100_ind_desativado
                            ? AtivarFiliado(row.fi100_key_public)
                            : DesativarFiliado(row.fi100_key_public)
                    }
                >
                    {row.fi100_ind_desativado ? 'Desativado' : 'Ativado'}
                </button>
            ),
        },
        {
            id: 'acoes',
            header: () => '',
            label: 'Ações',
            canHide: false,
            className: 'tw-align-top tw-text-right',
            cell: ({ row }) => (
                <div class="dropdown tw-inline-flex tw-justify-end">
                    <button class="dropdown-acao btn-dropdown btn btn-secondary" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                        <span class="material-symbols-outlined">more_vert</span>
                    </button>
                    <ul class="dropdown-menu">
                        <li>
                            <button type="button" class="dropdown-item align-icon" onClick={() => Editar(row.fi100_key_public)}>
                                <span class="material-symbols-outlined">edit</span>Editar
                            </button>
                        </li>
                        <li>
                            <button type="button" class="dropdown-item align-icon" onClick={() => ResetarSenha(row.fi100_key_public)}>
                                <span class="material-symbols-outlined">password</span>Alterar Senha
                            </button>
                        </li>
                        <li>
                            {row.fi100_ind_desativado ? (
                                <button type="button" class="dropdown-item align-icon" onClick={() => AtivarFiliado(row.fi100_key_public)}>
                                    <span class="material-symbols-outlined">do_not_disturb_on</span>Ativar
                                </button>
                            ) : (
                                <button type="button" class="dropdown-item align-icon action-disable" onClick={() => DesativarFiliado(row.fi100_key_public)}>
                                    <span class="material-symbols-outlined">do_not_disturb_on</span>Desativar
                                </button>
                            )}
                        </li>
                    </ul>
                </div>
            ),
        },
    ], [AtivarFiliado, DesativarFiliado, Editar, ResetarSenha]);

    const [colunasVisiveis, setColunasVisiveis] = useState(() =>
        Object.fromEntries(colunasBase.map(coluna => [coluna.id, true])),
    );

    const colunasTabela = useMemo(
        () => colunasBase.filter(coluna => colunasVisiveis[coluna.id] !== false),
        [colunasBase, colunasVisiveis],
    );

    const dadosFiltrados = useMemo(() => {
        const busca = filtroTexto.trim().toLowerCase();
        if (!busca) {
            return PesquisaFiliados;
        }
        return PesquisaFiliados.filter((item) => {
            const campos = [
                item.fi100_dsc_filiado,
                item.fi100_num_cnpj,
                item.fi100_num_telefone,
                item.fi100_dsc_email,
                obterDescricaoAssociado(item),
            ];
            return campos.some((campo) => (campo || '').toString().toLowerCase().includes(busca));
        });
    }, [PesquisaFiliados, filtroTexto]);

    const toggleColuna = useCallback((colunaId) => {
        const coluna = colunasBase.find(col => col.id === colunaId);
        if (coluna?.canHide === false) {
            return;
        }
        setColunasVisiveis((anteriores) => ({
            ...anteriores,
            [colunaId]: anteriores[colunaId] === false,
        }));
    }, [colunasBase]);

    return (
        <div class="row">
            <div class="container">
                <Topo titulo='Filiado' breadcrumbs={breadcrumbs} btnincluir={true} destino='/admin/filiado/novo' admin={true}/>
                <ListagemFeedback
                    displayErro={exibeErro}
                    mensagemErro={mensagemErro}
                    displaySucesso={exibeSucesso}
                    mensagemSucesso={mensagemSucesso}
                />
            </div>
            <ListagemOpcoes
                esconderTamanhoPagina={true}
                esconderOpcaoFiltro={true}
                esconderCampoFiltro={true}
            />            
            <div class="row row-padding-conteudo">
                <div class="col-12">
                    <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-4 tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white/90 tw-p-4 tw-shadow-sm dark:tw-border-slate-700 dark:tw-bg-slate-900/70">
                        <div class="tw-flex tw-min-w-[240px] tw-flex-1 tw-items-center tw-gap-3">
                            <label for="filtro-filiado" class="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-600 dark:tw-text-slate-300">
                                Pesquisa:
                            </label>
                            <input
                                id="filtro-filiado"
                                type="search"
                                class="form-control tw-h-11 tw-flex-1 tw-rounded-lg tw-border tw-border-slate-200/70 tw-bg-white/95 tw-px-3 tw-py-2 tw-text-sm tw-text-slate-700 placeholder:tw-text-slate-400 focus:tw-border-indigo-400 focus:tw-ring-2 focus:tw-ring-indigo-300 dark:tw-border-slate-700 dark:tw-!bg-slate-900/70 dark:tw-text-slate-100 dark:placeholder:tw-text-slate-500 dark:focus:tw-ring-indigo-400/40"
                                placeholder="Busque por nome, CNPJ, telefone ou e-mail..."
                                value={filtroTexto}
                                onChange={evento => setFiltroTexto(evento.target.value)}
                            />
                        </div>
                        <div class="tw-flex tw-ml-auto tw-items-center">
                            <ColumnToggleDropdown
                                colunas={colunasBase}
                                visibilidade={colunasVisiveis}
                                onToggle={toggleColuna}
                                label="Colunas"
                                align="end"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="row row-padding-conteudo">
                <div class="col-12 mobile-hide tablet-hide">
                    <div class="admin-emplacar-table-wrapper table-responvive">
                        <DataTable
                            columns={colunasTabela}
                            data={dadosFiltrados}
                            getRowId={(row, index) => row.fi100_key_public || index}
                            className="tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-white tw-shadow-lg dark:tw-border-slate-800 dark:tw-bg-slate-900"
                        />
                    </div>
                </div>
            </div>
            <FiliadoCard />
            <Paginacao esconder={true} />
        </div>
    )

}

export default FiliadoTabela;
